import React from 'react'
import { connect } from 'react-redux'
import styled, { createGlobalStyle } from 'styled-components'
import { getUser } from 'shared/redux/reducers'
import { LoggedInUser } from 'shared/types/user'
import { giphyWhite } from '@giphy/js-brand'

const GlobalStyle = createGlobalStyle`
    body {
        margin-top: 125px;
    }
`

const StyledHeader = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 125px;
    background: rgb(154, 51, 254);
    background: linear-gradient(135deg, rgba(154, 51, 254, 1) 0%, rgba(253, 101, 99, 1) 100%);
`

const Inner = styled.div`
    width: 1040px;
    height: 100%;
    position: relative;
    margin: auto;
`

const Logo = styled.div`
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 125px;
    width: 460px;
    background-image: url('/static/img/supercut/header-logo.gif');
    background-repeat: no-repeat;
    background-size: contain;
`

const BetaIcon = styled.div`
    text-align: center;
    position: absolute;
    top: calc(50% + 3px);
    left: calc(50% + 275px);
    transform: translate(-50%, -50%);
    height: 26px;
    width: 58px;
    background-image: url('/static/img/supercut/beta_pill@2x.png');
    background-repeat: no-repeat;
    background-size: contain;
`

const User = styled.a`
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
`

const AvatarImg = styled.img`
    width: 36px;
    height: 36px;
    display: inline-block;
    vertical-align: middle;
`

const Username = styled.div`
    color: ${giphyWhite};
    font-size: 17px;
    font-weight: bold;
    height: 36px;
    line-height: 36px;
    display: inline-block;
    margin-right: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 132px;
    vertical-align: bottom;
`

const GiphyLink = styled.a`
    font-size: 17px;
    font-weight: bold;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
`

const BackArrow = styled.span`
    vertical-align: middle;
    margin-right: 15px;
`

type Props = {
    loggedInUser: LoggedInUser
}

const Header = ({ loggedInUser }: Props) => (
    <>
        <GlobalStyle />
        <StyledHeader>
            <Inner>
                <GiphyLink href="/">
                    <BackArrow className={'ss-navigateleft'} /> GIPHY.COM
                </GiphyLink>
                <Logo></Logo>
                <BetaIcon />
                <User href={`/${loggedInUser.username}`}>
                    <Username>{loggedInUser.displayName}</Username>
                    <AvatarImg src={loggedInUser.avatar} />
                </User>
            </Inner>
        </StyledHeader>
    </>
)

export default connect(state => ({ loggedInUser: getUser(state) }), {})(Header)
